import { Text } from '@village/ui';
import styled from 'styled-components';

const Container = styled.div`
    display: grid;
    gap: 0.25rem;
    text-align: center;
    color: ${({ theme }) => theme.vui.colors.text.grayMuted};
    padding-bottom: 0.5rem;
`;

// Override h1 styles as per design specifically for this project
const Title = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    font-size: 3rem;
    font-weight: 300;
`;

export { Container, Title };
